import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","text-align":"right"} }

import { h, reactive, ref, onMounted, unref } from 'vue';
import { useRouter } from 'vue-router';

import { ElButton, ElTag } from 'element-plus';
import moment from 'moment';

/* Components */
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { useLocales } from '@/hooks/useLocales';
import { DeptTreeList } from '@/components/lists/Index';

import DeptWriter from './components/DepartmentWriter.vue';

/* API */
import { GetDeptListApi, DelDeptApi } from '@/apis/basics/department/apis';

/* Dtos */
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { DeptSearchDto, DeptListDto, DeptDeleteDto } from '@/apis/basics/department/dtos';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const deptRef = ref<ComponentRef<typeof DeptWriter>>();

const state = reactive({
	loading: false,
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<DeptListDto>({
	getListApi: GetDeptListApi,
	delListApi: DelDeptApi,
	response: { data: 'data', total: 'total' },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'dept_code', label: t('basics.department.table.deptCode', '部门编号'), columnWidth: '120' },
	{ field: 'dept_name', label: t('basics.department.table.deptName', '部门名称'), columnWidth: '180' },
	{ field: 'company_name', label: t('basics.department.table.companyName', '所属公司'), columnWidth: '240' },
	{ field: 'remark', label: t('basics.department.table.remark', '备注') },
	{ field: 'sort', label: t('basics.department.table.sort', '排序'), columnWidth: '80', align: 'center' },
	{ field: 'is_enabled', label: t('basics.department.table.status', '状态'), columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: t('basics.department.table.createdTime', '创建时间'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '120px', label: t('basics.department.table.actions', '操作'), fixed: 'right', align: 'center' },
]);

/* 选择节点 */
const onNodeChange = (nodeId: string) => {
	state.search.pid = nodeId;
	actions.search();
};

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},

	/* 创建 */
	create: () => {
		unref(deptRef)?.create();
	},

	/* 编辑*/
	modify: (row: any) => {
		unref(deptRef)?.editor(row.id);
	},

	/* 删除 */
	delete: async (row: any) => {
		const deleteDto: DeptDeleteDto = { id: row.id, revision: row.revision };
		await methods.deleteRows(deleteDto);
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_unref(DeptTreeList), {
              pid: `10000000-0000-0000-0000-000000000001`,
              onNodeChange: onNodeChange
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"text-align":"left"},
              "body-style": { paddingBottom: '0' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  size: "small",
                  model: _unref(state).search,
                  inline: true,
                  class: "demo-form-inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      "label-width": '80px',
                      label: _unref(t)('basics.department.search.deptCode', '部门编号')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).search.dept_code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.dept_code) = $event)),
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, {
                      "label-width": '80px',
                      label: _unref(t)('basics.department.search.deptName', '部门名称')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(state).search.dept_name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.dept_name) = $event)),
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              icon: "Refresh",
                              onClick: actions.reSetSearch
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('basics.department.search.buttons.reset', '重置')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_unref(ElButton), {
                              type: "primary",
                              icon: "Search",
                              onClick: actions.search
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('basics.department.search.buttons.search', '查询')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              shadow: "never",
              style: {"margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(ElButton), {
                    size: "small",
                    type: "primary",
                    onClick: actions.create
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('basics.department.search.buttons.createDept', '创建部门')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_unref(GbTables), {
                  pageSize: _unref(tableObject).pageSize,
                  "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
                  currentPage: _unref(tableObject).currentPage,
                  "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
                  columns: _unref(tabColumns),
                  data: _unref(tableObject).tableList,
                  loading: _unref(tableObject).loading,
                  pagination: { total: _unref(tableObject).total },
                  onRegister: _unref(register)
                }, {
                  created_time: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
                  ]),
                  is_enabled: _withCtx(({ row }) => [
                    (row.is_enabled == 'Y')
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 0,
                          size: "small",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('basics.department.options.enabled', '启用')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (row.is_enabled == 'N')
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 1,
                          size: "small",
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('basics.department.options.disabled', '停用')), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  action: _withCtx(({ row }) => [
                    _createVNode(_unref(ElButton), {
                      size: "small",
                      type: "success",
                      link: "",
                      onClick: ($event: any) => (actions.modify(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.department.buttons.edit', '编 辑')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      size: "small",
                      type: "danger",
                      link: "",
                      onClick: ($event: any) => (actions.delete(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('basics.department.buttons.delete', '删 除')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(DeptWriter, {
      ref_key: "deptRef",
      ref: deptRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"])
  ], 64))
}
}

})